// extracted by mini-css-extract-plugin
export default {"bg_custom":"owner_profile_bg_custom__k7lbP","line":"owner_profile_line__1YIDC","dashboard":"owner_profile_dashboard__PxNOY","profiledata":"owner_profile_profiledata__eP3am"};